import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function FaceWithInformationIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      width="72"
      height="59"
      viewBox="0 0 72 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.97 25.1625C45.5388 25.8527 39 29.1878 39 43.2091C39 47.1735 40.6487 50.3283 43.1815 52.6108C39.1194 55.3725 34.0395 57 28.1163 57C14.8663 57 1 49.0034 1 34.1977C1 6.77326 16.0838 4 30.8895 4C42.6624 4 50.3248 13.7319 52.97 25.1625Z"
        fill="#D1DBF2"
      />
      <path
        d="M25.7801 15.2064C26.1271 15.1479 26.4773 15.1155 26.8282 15.1094C27.4705 15.1094 27.558 16.6861 27.7274 18.333C27.8466 19.4846 27.9564 21.3751 27.962 22.5329C27.9781 25.5873 27.9942 28.6417 28.0104 31.6961C28.0166 31.7495 28.013 31.8036 27.9999 31.8554C27.9868 31.9072 27.9644 31.9555 27.934 31.9975C27.8949 32.0285 27.8504 32.0502 27.8033 32.0612C27.7562 32.0723 27.7075 32.0723 27.6604 32.0614C27.0144 32.0139 25.661 32.4742 25.6033 31.7518C25.1099 25.5254 25.6033 21.9282 24.8214 16.6758C24.7956 16.5087 24.8001 16.3376 24.8344 16.1725C24.8688 16.0073 24.9324 15.8513 25.0216 15.7137C25.1108 15.576 25.2238 15.4593 25.354 15.3705C25.4842 15.2816 25.6291 15.2223 25.7801 15.1961V15.2064ZM36.8848 34.2408C36.8155 35.3902 36.5402 36.5128 36.075 37.5429C35.3434 39.1692 34.4424 40.7686 33.2174 42.0069C30.2574 44.9953 25.5344 45.3956 22.014 43.2823C18.8697 41.396 16.7586 37.7451 16.1703 33.8301C16.1449 33.6479 16.154 33.4619 16.1969 33.2839C16.2398 33.1058 16.3157 32.9395 16.4197 32.7957C16.5237 32.6519 16.6535 32.5336 16.801 32.4484C16.9484 32.3632 17.1102 32.313 17.2761 32.3008C17.6373 32.2706 17.9985 32.243 18.3596 32.2183C18.5108 32.208 18.6609 32.252 18.7877 32.3439C18.9145 32.4357 19.0111 32.5704 19.0633 32.728C19.3174 33.4963 19.6288 34.2397 19.9941 34.9507C21.1577 37.2209 23.1943 39.0536 25.5362 39.3177C28.1965 39.617 30.8196 37.8091 32.2158 35.2809C32.51 34.7464 32.8637 34.0427 33.2118 33.2935C33.2934 33.116 33.4226 32.9709 33.5816 32.8781C33.7406 32.7854 33.9217 32.7495 34.0998 32.7755C34.7278 32.8663 35.3564 32.9667 35.9857 33.0768C36.2686 33.1263 36.5814 33.1965 36.7508 33.4524C36.8744 33.6872 36.9217 33.9618 36.8848 34.2305V34.2408ZM36.9761 19.9552C36.371 21.049 35.2373 21.8312 34.0868 21.7012C33.0741 21.5876 32.1935 20.7951 31.689 19.8128C31.1845 18.8304 30.9332 16.7501 30.9332 16.7501C30.9332 16.5912 31.2236 16.4942 31.6462 16.4261C31.6919 16.419 31.7385 16.4287 31.7788 16.4537C31.8191 16.4786 31.851 16.5175 31.8696 16.5644C31.9329 16.715 32.0017 16.8657 32.0799 17.0184C32.5044 17.8439 33.2472 18.5146 34.1017 18.6096C35.0697 18.719 36.0266 18.0606 36.5349 17.1381C36.6317 16.9627 36.7471 16.7398 36.8606 16.4942C36.8976 16.4153 36.9535 16.3494 37.0222 16.3035C37.0908 16.2576 37.1696 16.2336 37.2497 16.2341H37.5811C38.739 16.2424 37.5792 18.851 36.9761 19.9449V19.9552Z"
        fill="#4E7FFF"
      />
      <path
        d="M72 43.8765C71.157 50.7893 65.9385 56.3533 57.8372 56.3533C50.5872 56.3533 43 51.9778 43 43.8765C43 28.8707 51.2534 27.3533 59.3547 27.3533C67.4559 27.3533 72 35.7753 72 43.8765Z"
        fill="currentColor"
      />
      <path
        d="M56 48.5655H60.5647"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M58.2878 48.5648V40.1676H56.0156"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M58.1778 34.2353C58.1778 34.5082 57.9565 34.7294 57.6836 34.7294C57.4107 34.7294 57.1895 34.5082 57.1895 34.2353C57.1895 33.9623 57.4107 33.7411 57.6836 33.7411"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.6826 33.7412C57.9556 33.7412 58.1768 33.9625 58.1768 34.2354"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
